import { FUNCT_COOKIES } from "../constants";

export default (cookies) => {
	FUNCT_COOKIES.forEach((cookie) => {
		if (cookies[cookie]) {
			// document.cookie = cookie + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			document.cookie = cookie + '=; Max-Age=0; domain=.ramirent.sk'
		}
	})
}